import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5 12V4m14 16v-3M5 20v-4m14-3V4m-7 3V4m0 16v-9M5 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM19 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  stroke: "#2D2B29",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }